import { Link } from "react-router-dom";
import styled from "styled-components/macro";

export const FooterWrapper = styled.footer`
  width: 100%;
  padding: 40px 26px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #000;
  background-color: #eeeff0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #eeeff0;
`;

export const Logo = styled.img`
  display: block;
  width: 100%;
  margin-bottom: 38px;
`;

export const BlockSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-bottom: 10px;
`

export const SectionTitle = styled.span`
  display: block;
  font-weight: 400;
  color: #A7A7A7;
  line-height: 22px;
  margin-bottom: 14px;
  text-align: left;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 36px;
    
  @media (max-width: 576px) {
    width: 100%;  
  }
`

export const Copyright = styled(SectionTitle)`
  margin-bottom: 0;
  text-align: center;
`;

export const StyledLink = styled(Link)`
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  text-decoration: none;
  color: black;

  &:last-child {
    margin-top: auto;
    margin-bottom: 14px;
  }
  
  &:hover {
    color: #1983ff;
  }
`;

export const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #141414;
  text-decoration: none;
  transition: color 0.2s ease;

  svg {
    display: block;
    width: auto;
    height: 40px;
  }

  svg path {
    fill: currentColor;
    transition: fill 0.2s ease;
  }

  &:hover {
    color: #1983ff;
  }
`;

export const LegalInfo = styled(SectionTitle)`
  margin-bottom: 24px;
  text-align: left;
`

export const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 26px;
  margin-top: 12px;
`

export const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 40px;
  margin-bottom: 14px;
`;
